module.exports = __webpack_public_path__ + "static/media/rep-icon.69126a09.svg";